import React, { useState } from "react";
import { ReactComponent as UploadIcon } from "../../../assets/icons/upload.svg";
import { Button } from "../../../components/Button";
import { CourseSelection } from "./CourseSelection";
import { CourseForm } from "../../content/ContentDetails/components/CourseForm";
import { ContentDetails } from "../../content/ContentDetails/ContentDetails";
import { api } from "../../../helpers/api";

type PlaylistUploadProps = {
  onBack: () => void;
  onSubmit: (selectedCourses: any[]) => void;
  loading: boolean;
  initialSelectedCourses?: any[];
};

type StepType = "courses" | "create" | "content_details";

export function PlaylistUpload({
  onBack,
  onSubmit,
  loading,
  initialSelectedCourses = [],
}: PlaylistUploadProps) {
  const [step, setStep] = useState<StepType>("courses");
  const [createdCourse, setCreatedCourse] = useState<any>(null);

  const handleCourseCreated = async (course: any) => {
    try {
      const response = await api.getContents({
        page: 1,
        limit: 10,
        keyword: course.title,
        type: "all",
      });

      const matchingCourse = response?.data?.publisherVideo?.find(
        (c: any) =>
          c.title === course.title &&
          c?.publisher_data?.publisher_id === course.publisher_id
      );

      if (matchingCourse) {
        setCreatedCourse(matchingCourse);
        setStep("content_details");
      }
    } catch (error) {
      console.error("Error fetching course list:", error);
    }
  };

  const renderStep = () => {
    switch (step) {
      case "courses":
        return (
          <div className="flex flex-col gap-4 p-6">
            <div className="flex justify-between items-center">
              <h3 className="text-lg font-medium">Select Courses</h3>
              <div className="flex gap-2">
                <Button
                  variant="outline"
                  onClick={() => setStep("create")}
                  disabled={loading}
                >
                  Create New Course
                </Button>
                <Button variant="primary" onClick={onBack} disabled={loading}>
                  Back
                </Button>
              </div>
            </div>
            <CourseSelection
              loading={loading}
              onBack={onBack}
              selectedCourses={initialSelectedCourses}
              onSubmit={(courses) => {
                onSubmit(courses);
              }}
            />
          </div>
        );

      case "create":
        return (
          <div className="w-screen h-screen">
            <div className="flex flex-col gap-4 p-6">
              <div className="flex justify-between items-center">
                <h3 className="text-lg font-medium">Create New Course</h3>
                <Button
                  variant="outline"
                  onClick={() => setStep("courses")}
                  disabled={loading}
                >
                  Back to Course Selection
                </Button>
              </div>
              <CourseForm
                onClose={() => setStep("courses")}
                onCourseCreated={handleCourseCreated}
              />
            </div>
          </div>
        );

      case "content_details":
        return (
          <div className="w-screen h-screen">
            <ContentDetails
              course={createdCourse}
              isOpen={true}
              onClose={() => {
                setStep("courses");
              }}
              refresh={() => {
                setStep("courses");
              }}
            />
          </div>
        );
    }
  };

  return (
    <div
      className={`${
        step === "create" || step === "content_details"
          ? "w-screen h-screen max-w-none"
          : "w-full"
      }`}
    >
      {renderStep()}
    </div>
  );
}
